import React, { useContext } from 'react';
import { formatTimestamp } from '@buzzfeed/bf-utils/lib/timestamp';
import { ProfileUserContext } from '../../contexts/profileUser';
import { CdnImage } from '@buzzfeed/react-components';
import styles from './TrophyList.scss';

function EarnedTrophy({ id, image, imageAlt, name, description, trophyDate }) {
  return (
    <li className={styles.listItem} id={`trophy-${id}`}>
      <CdnImage className={styles.image} src={`${image}?resize=100:100&output-format=auto&output-quality=auto`} alt={imageAlt} />
      <div className={styles.trophyInfo}>
        <time className={styles.date}>
          Earned {formatTimestamp(trophyDate).formattedTimestamp}
        </time>
        <h3 className={styles.title}>{name}</h3>
      </div>
      <p className={styles.description}>{description}</p>
    </li>
  );
}

function UnearnedTrophy({ id, image, imageAlt, name, description }) {
  return (
    <li className={styles.unearnedListItem} id={`trophy-${id}`}>
      <CdnImage
        className={styles.image}
        src={`${image}?resize=100:100&output-format=auto&output-quality=auto`}
        alt={imageAlt}
      />
      <div className={styles.trophyInfo}>
        <p className={styles.date}>Not yet earned</p>
        <h3 className={styles.title}>{name}</h3>
      </div>
      <p className={styles.description}>{description}</p>
    </li>
  );
}

function TrophyList({ trophies = [] }) {
  // For the first trophy, You Exist, use the user's account creation
  // date because there's no data in the achievedAt field and that's
  // what the trophy's for anyway.
  const { memberSince } = useContext(ProfileUserContext);
  const trophyReturn = trophies.map((trophyProps, index) => {
    const trophyDate = index === 0 ? memberSince : trophyProps.achievedAt;
    if (trophyProps.earned) {
      return <EarnedTrophy {...{ trophyDate, ...trophyProps }} />;
    }

    return <UnearnedTrophy {...trophyProps} />;
  });

  return <ul className={styles.list}>{trophyReturn}</ul>;
}

export default TrophyList;
